function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M131.938 38.773C131.323 32.723 126.214 28 120 28H-8c-6.627 0-12 5.373-12 12v80c0 .414.021.823.062 1.227C-19.323 127.277-14.213 132-8 132h128c6.627 0 12-5.373 12-12V40c0-.414-.021-.823-.062-1.227z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M-20 57.511h152"
});

var SvgCard = function SvgCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-24 24 160 112",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgCard;